module.exports = __webpack_public_path__ + "static/img/IMG-Sewerage System_400_300.e73121f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IMG-Sewerage System_400_300.jpg
// module id = tiOU
// module chunks = 7